module.exports = __webpack_public_path__ + "static/img/Slide-form-1.3ca12bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Slide-form-1.png
// module id = tK0/
// module chunks = 0